/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, October 3rd 2022, 12:21:22 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { WritableModel } from "lib/schemas/abstract";
import { schemaBuilder, Many2OneIntPKBaseSchema } from "lib/validation";
import { Portal } from "./Portal";

export interface WebsiteMenu extends WritableModel<false> {
  name: string;
  url?: any;
  new_window: boolean;
  sequence?: any;
  parent?: any;
  site: Portal["id"];
  readonly site_name?: Portal["name"];
  readonly menu_url?: string;
  published_page?: WebsitePage;
}

export interface WebsitePage extends WritableModel<false> {
  title: string;
  content: string;
  menu: WebsiteMenu["id"];
  readonly site_name?: Portal["name"];
}

// TODO: Create proper validation schema
export const WebsitePageValidationSchema: schemaBuilder.SchemaOf<Omit<WebsitePage, "id" | "site_name">> = schemaBuilder
  .object()
  .shape({
    content: schemaBuilder.string().required("Page content is required"),
    menu: Many2OneIntPKBaseSchema().optional(),
    title: schemaBuilder.string().required("Page title is required"),
  });

type WriteOnlyWebsiteMenu = Omit<WebsiteMenu, "id" | "site_name" | "menu_url">;

// TODO: Create proper validation schema
export const WebsiteMenuValidationSchema: schemaBuilder.SchemaOf<WriteOnlyWebsiteMenu> = schemaBuilder.object().shape({
  name: schemaBuilder.string().required("Menu title is required"),
  new_window: schemaBuilder.boolean().optional().default(false),
  parent: Many2OneIntPKBaseSchema().optional().nullable(),
  sequence: schemaBuilder.number().optional().nullable(),
  site: Many2OneIntPKBaseSchema().required("Site id is required"),
  url: schemaBuilder.string().url().optional(),
  published_page: WebsitePageValidationSchema.optional(),
});
